import React from 'react';
import { t } from '../i18n';
import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center h-[60vh] text-center">
      <h1 className="text-6xl font-bold text-error mb-4">404</h1>
      <div className="text-2xl mb-2">{t('not_found') || '页面未找到'}</div>
      <Link to="/welcome" className="btn btn-primary mt-4">{t('back_home') || '返回首页'}</Link>
    </div>
  );
}

export default NotFoundPage; 